import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
  max-height: 5rem;
`

export const Title = styled.label`
  font-size: ${(props) => props.theme.font.textsm};
  color: #494949;
`

export const Map = styled.div<{ background: string; border: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1.4rem;
  gap: 0.5rem;
  min-width: fit-content;
  cursor: pointer;

  > svg {
    border: 1px solid #bb0000;
    border-radius: 6px;
    padding: 0.2rem;
  }
  > span {
    font-size: ${(props) => props.theme.font.textsm};
  }
  > div {
    background-color: ${(props) => props.background};
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 2.5rem;
    min-height: 2.5rem;
    border: ${(props) => (props.border ? '' : '1px solid #BB0000')};
    border-radius: 6px;
  }
`
export const FooterMapCanva = styled.div`
  overflow: hidden;
  background: none !important;
`
